import script from "./ColumnEditorPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnEditorPanel.vue?vue&type=script&setup=true&lang=js"

import "./ColumnEditorPanel.vue?vue&type=style&index=0&id=3edcf4ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3edcf4ce"]])

export default __exports__